export function arrayOfObjectsFilteredByKeys(array=[], keysToKeep=[]) {
    const regex = new RegExp(`^${keysToKeep.join('|')}$`, 'i')

    return array.map((obj) => (
        Object.fromEntries(
            Object.entries(obj)
                  .filter(([key]) => regex.test(key))
        )
    ))
}

export function pluckKeyFromObjectsInArray(array=[], key='') {
    return arrayOfObjectsFilteredByKeys(array, [key])
               ?.map(obj => Object.values(obj))
               ?.flat()
}

export function parentAndCollectionIndiciesFor(data, key, parentId, itemId) {
    const parentIndex     = data[key].findIndex((item) => item.id === parentId)
    const collectionIndex = data[key][parentIndex].collection.findIndex((item) => item.id === itemId)

    return [parentIndex, collectionIndex]
}

export function toggleObjectSubObjectAttribute(form, path='', parentId, itemId, pathSeparator='/') {
    const [object, subObject, attribute] = path.split(pathSeparator)
    if (!object || !subObject || !attribute) { throw('toggleObjectSubObjectAttribute is missing a dependency!') }
    const [parentIndex, collectionIndex] = parentAndCollectionIndiciesFor(form, object, parentId, itemId)
    const copy = [...form[object]]
    copy[parentIndex][subObject][collectionIndex][attribute] = !copy[parentIndex][subObject][collectionIndex][attribute]

    return copy
}

/*!
 * Add items to an object at a specific path
 * (c) 2021 Chris Ferdinandi, MIT License, https://gomakethings.com
 * https://gomakethings.com/adding-items-to-an-object-at-a-specific-path-with-vanilla-js/
 *
 * @param  {Object}       object  The object
 * @param  {String|Array} path    The path to assign the value to
 * @param  {*}            value   The value to assign
 */
export function setPropertyByPath(object={}, path=null, value=null) {
    if (!path || !value) { return }

    /**
     * If the path is a string, convert it to an array
     * @param  {String|Array} path The path
     * @return {Array}             The path array
     */
    const stringToPath = (path) => {
        if (typeof path !== 'string') { return path }

        let output = []

        path.split('.').forEach((item) => {                  // Split to an array with dot notation
            item.split(/\[([^}]+)\]/g).forEach((key) => {    // Split to an array with bracket notation
                if (key.length > 0) { output.push(key) }
            })
        })

        return output
    }

    // Convert the path to an array if not already
    path = stringToPath(path)

    // Cache the path length and current spot in the object
    let length  = path.length
    let current = object

    // Loop through the path
    path.forEach((key, index) => {
        // Check if the assigned key should be an array
        let isArray = key.slice(-2) === '[]'

        // If so, get the true key name by removing the trailing []
        key = isArray ? key.slice(0, -2) : key

        // If the key should be an array and isn't, create an array
        if (isArray && !Array.isArray(current[key])) {
            current[key] = []
        }

        // If this is the last item in the loop, assign the value
        if (index === length -1) {
            // If it's an array, push the value
            // Otherwise, assign it
            if (isArray) {
                current[key].push(value)
            } else {
                current[key] = value
            }

        // Otherwise, update the current place in the object
        } else {
            // If the key doesn't exist, create it
            if (!current[key]) { current[key] = {} }

            // Update the current place in the object
            current = current[key]
        }
    })
}
